import { Box, Container, Typography, IconButton, Stack } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#0f2f24",
        color: "#fff",
        py: 5,
        mt: 8
      }}
    >
      <Container maxWidth="lg">
        {/* Social Icons */}
        <Stack
          direction="row"
          spacing={3}
          justifyContent="center"
          alignItems="center"
          mb={3}
        >
          <IconButton
            component="a"
            href="https://x.com/alshaikhlawfirm?s=11&t=8eUfNTcJNcBfEqSl9MYbiw"
            target="_blank"
            sx={{ color: "#fff" }}
          >
            <XIcon />
          </IconButton>

          <IconButton
            component="a"
            href="https://www.linkedin.com/in/%D8%B4%D8%B1%D9%83%D8%A9-%D9%87%D8%B4%D8%A7%D9%85-%D8%B9%D8%A8%D8%AF%D8%A7%D9%84%D9%84%D9%87-%D8%A7%D9%84%D8%B4%D9%8A%D8%AE-%D9%88%D8%B4%D8%B1%D9%83%D8%A7%D8%A4%D9%87-%D9%84%D9%84%D9%85%D8%AD%D8%A7%D9%85%D8%A7%D8%A9-%D9%88%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A7%D9%84%D9%82%D8%A7%D9%86%D9%88%D9%86%D9%8A%D8%A9-116641270"
            target="_blank"
            sx={{ color: "#fff" }}
          >
            <LinkedInIcon />
          </IconButton>

          <IconButton
            component="a"
            href="https://wa.me/+966550270014"
            target="_blank"
            sx={{ color: "#fff" }}
          >
            <WhatsAppIcon />
          </IconButton>
        </Stack>

        {/* Caption */}
        <Typography
          variant="body2"
          align="center"
          sx={{
            opacity: 0.8,
            fontSize: "0.95rem",
            letterSpacing: 0.5
          }}
        >
          Hisham Abdullah Al-Sheikh and Partners Law Firm and Legal
          Consultations All Right Recived © 2026
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;